import React, { Component, createRef } from 'react'
import * as PropTypes from 'prop-types'
import axios from 'axios'
import { debounce } from 'lodash'
import { Col, Form, message, Modal, Row, Select, Spin, Input } from 'antd'

import { API_ERRO_TYPE_CANCEL } from './../../config/general'
import {
  integrationsService,
  companiesService,
  departmentsService,
  employeesService,
} from './../../redux/services'

import { UIDrawerForm, UIFormSection, UIInfoBanner } from './../../components';
import TextArea from 'antd/lib/input/TextArea';
import ColumnTable from './table';
import EventColumnTable from './tableEvents';
import LayoutPreview from './layoutPreview';

const formId = `form-drawer-${Math.floor(Math.random() * 10001)}`

class Edit extends Component {
  static propTypes = {
    visible: PropTypes.bool.isRequired,
    onComplete: PropTypes.func.isRequired,
    onClose: PropTypes.func.isRequired,
  }

  constructor(props) {
    super(props)

    this.state = {
      isLoading: true,
      isSending: false,
      uuid: 0,
      companies: [],
      companiesIsLoading: false,
      departments: [],
      departmentsIsLoading: false,
      employees: [],
      employeesIsLoading: false,

      // Dados das tabelas
      eventData: [],
      eventDataIsLoading: false,
      eventData: [],
      eventColumnDataIsLoading: false,

      layoutRows: [],
      layoutTypeSections: [],
      layoutColumnOptions: [],
    }

    this.eventColumnTableRef = createRef();
    this.columnTableRef = createRef();

    this._axiosCancelCompaniesToken = null
    this._axiosCancelDepartmentsToken = null
    this._axiosCancelEmployeesToken = null
  }

  handleTabClick = () => { }

  onLayoutRowsChange = (layoutRows, layoutTypeSections, layoutColumnOptions) => {
    this.setState({ layoutRows, layoutTypeSections, layoutColumnOptions })
  }

  fetchCompanies = () => {
    if (this._axiosCancelCompaniesToken) {
      this._axiosCancelCompaniesToken.cancel('Only one request allowed at a time.')
    }

    this._axiosCancelCompaniesToken = axios.CancelToken.source()

    this.setState({ companiesIsLoading: true })

    companiesService
      .getAutocomplete({
        orderBy: 'nome:asc',
        ativo: 1,
        cancelToken: this._axiosCancelCompaniesToken.token,
      })
      .then((response) => {
        this.setState({
          companiesIsLoading: false,
          companies: response.data.data,
        })
      })
      .catch((data) => {
        if (data.error_type === API_ERRO_TYPE_CANCEL) return null

        this.setState({ companiesIsLoading: false })

        Modal.error({
          title: 'Ocorreu um erro!',
          content: String(data),
        })
      })
  }

  fetchDepartments = (value) => {
    if (this._axiosCancelDepartmentsToken) {
      this._axiosCancelDepartmentsToken.cancel('Only one request allowed at a time.')
    }

    this._axiosCancelDepartmentsToken = axios.CancelToken.source()

    // if (value !== undefined && !value.trim().length) {
      // this.setState({
        // departmentsIsLoading: false,
        // departments: [],
      // })
      // return false
    // }

    this.setState({ departmentsIsLoading: true })

    let params = {
      ...(value ? { search: value } : {}),
      is_active: 1,
      orderBy: 'nome:asc',
      cancelToken: this._axiosCancelDepartmentsToken.token,
      empresas_ids: (this.form.getFieldValue('empresas') || []).includes('todos')
        ? []
        : (this.form.getFieldValue('empresas') || []),
    }

    departmentsService
      .getAutocomplete({ ...params })
      .then((response) => {
        this.setState({
          departmentsIsLoading: false,
          departments: response.data.data,
        })
      })
      .catch((data) => {
        if (data.error_type === API_ERRO_TYPE_CANCEL) return null

        this.setState({ departmentsIsLoading: false })

        Modal.error({
          title: 'Ocorreu um erro!',
          content: String(data),
        })
      })
  }

  fetchDepartmentsSearch = debounce(this.fetchDepartments, 500)

  fetchEmployees = (value) => {
    if (this._axiosCancelEmployeesToken) {
      this._axiosCancelEmployeesToken.cancel('Only one request allowed at a time.')
    }

    this._axiosCancelEmployeesToken = axios.CancelToken.source()

    // if (value !== undefined && !value.trim().length) {
      // this.setState({
        // employeesIsLoading: false,
        // employees: [],
      // })
      // return false
    // }

    this.setState({ employeesIsLoading: true })

    let params = {
      ...(value ? { search: value } : {}),
      is_active: 1,
      orderBy: 'nome:asc',
      cancelToken: this._axiosCancelEmployeesToken.token,
      empresas_ids: (this.form.getFieldValue('empresas') || []).includes('todos')
        ? []
        : (this.form.getFieldValue('empresas') || []),
      departamentos_ids: (this.form.getFieldValue('departamentos') || []).includes('todos')
        ? []
        : (this.form.getFieldValue('departamentos') || []),
    }

    employeesService
      .getAutocomplete({ ...params })
      .then((response) => {
        this.setState({
          employeesIsLoading: false,
          employees: response.data.data,
        })
      })
      .catch((data) => {
        if (data.error_type === API_ERRO_TYPE_CANCEL) return null

        this.setState({ employeesIsLoading: false })

        Modal.error({
          title: 'Ocorreu um erro!',
          content: String(data),
        })
      })
  }

  fetchEmployeesSearch = debounce(this.fetchEmployees, 500)

  onCompanyChange = (value) => {
    if (value.length > 1 && value.includes('todos')) {
      this.form.setFieldValue('empresas', value.filter((item) => item !== 'todos'))
    }

    this.setState({
      employees: [],
      employeesIsLoading: false,
      departments: [],
      departmentsIsLoading: false,
    })

    this.form.setFieldValue('departamentos', ['todos'])
    this.form.setFieldValue('funcionarios', ['todos'])
  }

  onCompanySelect = (value) => {
    if (value === 'todos') {
      this.form.setFieldValue('empresas', ['todos'])
    }
  }

  onDepartmentChange = (value) => {
    if (value.length > 1 && value.includes('todos')) {
      this.form.setFieldValue(
        'departamentos',
        value.filter((item) => item !== 'todos')
      )
    }
  }

  onDepartmentSelect = (value) => {
    if (value === 'todos') {
      this.form.setFieldValue('departamentos', ['todos'])
    }
  }

  onEmployeeChange = (value) => {
    if (value.length > 1 && value.includes('todos')) {
      this.form.setFieldValue(
        'funcionarios',
        value.filter((item) => item !== 'todos')
      )
    }
  }

  onEmployeeSelect = (value) => {
    if (value === 'todos') {
      this.form.setFieldValue('funcionarios', ['todos'])
    }
  }

  onOpen = (uuid) => {
    this.setState({
      isLoading: true,
      uuid: uuid,
    })

    if (!this.state.companies.length) {
      this.fetchCompanies()
    }

    integrationsService
      .show({ uuid })
      .then((response) => {
        let item = response.data.data
        const eventColumnData = response?.data?.data?.eventos?.eventColumnData ?? []
        const eventData = response?.data?.data?.eventos?.eventData ?? []

        this.setState(
          {
            isLoading: false,
            employees: item.funcionarios ?? [],
            departments: item.departamentos ?? [],
            eventData: eventData,
            eventColumnData: eventColumnData,
          },
          () => this.fillForm(item)
        )
      })
      .catch((data) => {
        Modal.error({
          title: 'Ocorreu um erro!',
          content: String(data),
          onOk: () => this.onClose(),
        })
      })
  }

  fillForm = (data) => {
    this.form.setFieldsValue({
      empresas:
        (data.empresas ?? []).length > 0
          ? data.empresas.map((item) => item.id)
          : ['todos'],
      departamentos:
        (data.departamentos ?? []).length > 0
          ? data.departamentos.map((item) => item.id)
          : ['todos'],
      funcionarios:
        (data.funcionarios ?? []).length > 0
          ? data.funcionarios.map((item) => item.id)
          : ['todos'],
      layout: data.layout,
      description: data.descricao,
    })
  }

  resetFields = () => {
    this.form.resetFields()
  }

  onClose = () => {
    this.resetFields()
    this.props.onClose()
  }

  // Validação das colunas (mantive sua lógica original)
  validateColumnData = (eventData) => {
    if (!Array.isArray(eventData) || eventData.length === 0) {
      return false;
    }

    for (let i = 0; i < eventData.length; i++) {
      const item = eventData[i];
      const hasColumn = item && typeof item.column === 'string' && item.column.trim() !== '';
      if (!hasColumn) return false;

      if (item.column === 'TEXTO_FIXO') {
        const hasValue = typeof item.eventCode === 'string'
          ? item.eventCode.trim() !== ''
          : !!item.eventCode;
        if (!hasValue) return false;
      } else {
        if (!item.type) return false;
      }
    }
    return true;
  };

  // (opcional) validar eventos
  validateEventColumnData = (arr) => {
    if (!Array.isArray(arr)) return true // se não for obrigatório, aceite vazio
    for (const item of arr) {
      const vals = Object.values(item ?? {})
      const hasAny = vals.some(v => (v ?? '') !== '')
      if (!hasAny) continue
      if (!item?.eventType || !String(item.eventType).trim()) return false
      if (!item?.eventCode || !String(item.eventCode).trim()) return false
    }
    return true
  }

  onFinish = async (values) => {
    this.setState({ isSending: true })

    const { uuid } = this.state

    // Coleta os dados das duas tables
    const eventData = await this.columnTableRef.current.getFormData()
    const eventColumnData = await this.eventColumnTableRef.current.getFormData()

    // Monte o payload conforme o contrato do GET (eventos.{columnData,eventColumnData})
    let data = {
      ...values,
      uuid,
      eventos: { eventData, eventColumnData },
    }

    // validações
    if (!this.validateColumnData(eventData)) {
      message.error('Preencha os dados de Coluna e/ou Código corretamente!')
      this.setState({ isSending: false })
      return
    }

    if (!this.validateEventColumnData(eventColumnData)) {
      message.error('Preencha os dados de Eventos corretamente!')
      this.setState({ isSending: false })
      return
    }

    // normalizações de arrays
    if (!(values.empresas instanceof Array)) data.empresas = [values.empresas]
    if (!(values.departamentos instanceof Array)) data.departamentos = [values.departamentos]
    if (!(values.funcionarios instanceof Array)) data.funcionarios = [values.funcionarios]

    if ((data.empresas || []).includes('todos')) data.empresas = null
    if ((data.departamentos || []).includes('todos')) data.departamentos = null
    if ((data.funcionarios || []).includes('todos')) data.funcionarios = null

    integrationsService
      .edit(data)
      .then(() => {
        this.setState({ isSending: false })
        this.resetFields()
        message.success('Integração atualizada com sucesso.')
        this.props.onComplete()
      })
      .catch((err) => {
        this.setState({ isSending: false })
        Modal.error({
          title: 'Ocorreu um erro!',
          content: String(err),
        })
      })
  }

  render() {
    const { visible } = this.props
    const {
      isLoading,
      isSending,
      companiesIsLoading,
      companies,
      departments,
      departmentsIsLoading,
      employees,
      employeesIsLoading,
      eventData,
      eventDataIsLoading,
      eventColumnData,
      eventColumnDataIsLoading,
      layoutRows,
      layoutTypeSections,
      layoutColumnOptions,
    } = this.state

    return (
      <UIDrawerForm
        visible={visible}
        width="min(1400px, 100%)"
        onClose={this.onClose}
        isLoading={isLoading}
        isSending={isSending}
        formId={formId}
        icon={<i className="fal fa-plug" />}
        title={`Editar Integração`}
        subtitle="Configure o layout e os eventos para integração com a folha de pagamento."
      >
        <Form
          ref={(el) => (this.form = el)}
          id={formId}
          layout="vertical"
          scrollToFirstError
          onFinish={this.onFinish}
        >
          <Row gutter={16} className="integration-form">
            <Col xs={24} xl={12}>
              <UIFormSection icon={<i className="fal fa-id-card" />} title="Dados da integração">
                <Row gutter={16}>
                  <Col xs={24} md={12}>
                    <Form.Item
                      name="empresas"
                      label="Empresa"
                      rules={[{ required: true, message: 'Campo obrigatório.' }]}
                    >
                      <Select
                        ref={(el) => (this.empresas = el)}
                        mode="multiple"
                        optionFilterProp="children"
                        filterOption={(input, option) =>
                          (typeof option.children === 'string'
                            ? option.children
                            : option.children.props.children
                          )
                            .toLowerCase()
                            .indexOf(input.toLowerCase()) >= 0
                        }
                        allowClear
                        placeholder="Selecione a(s) empresa(s)"
                        notFoundContent={
                          companiesIsLoading ? (
                            <Spin indicator={<i className="fad fa-spinner-third fa-spin" />} />
                          ) : null
                        }
                        onChange={this.onCompanyChange}
                        onSelect={this.onCompanySelect}
                        showSearch
                      >
                        <Select.Option value="todos">Todas</Select.Option>
                        {companies.map((item, index) => (
                          <Select.Option key={index} value={item.id}>
                            {item.nome}
                          </Select.Option>
                        ))}
                      </Select>
                    </Form.Item>
                  </Col>
                  <Col xs={24} md={12}>
                    <Form.Item
                      name="departamentos"
                      label="Departamento"
                      rules={[{ required: true, message: 'Campo obrigatório.' }]}
                    >
                      <Select
                        mode="multiple"
                        optionFilterProp="children"
                        filterOption={(input, option) =>
                          (typeof option.children === 'string'
                            ? option.children
                            : option.children.props.children
                          )
                            .toLowerCase()
                            .indexOf(input.toLowerCase()) >= 0
                        }
                        allowClear
                        placeholder="Selecione o(s) departamento(s)"
                        notFoundContent={
                          departmentsIsLoading ? (
                            <Spin indicator={<i className="fad fa-spinner-third fa-spin" />} />
                          ) : null
                        }
                        onDropdownVisibleChange={(open) => open && this.fetchDepartments()}
                        onSearch={this.fetchDepartmentsSearch}
                        onChange={this.onDepartmentChange}
                        onSelect={this.onDepartmentSelect}
                        showSearch
                      >
                        <Select.Option value="todos">Todos</Select.Option>
                        {departments.map((item, index) => (
                          <Select.Option key={index} value={item.id}>
                            {item.nome}
                          </Select.Option>
                        ))}
                      </Select>
                    </Form.Item>
                  </Col>
                  <Col xs={24}>
                    <Form.Item
                      name="funcionarios"
                      label="Funcionário"
                      rules={[{ required: true, message: 'Campo obrigatório.' }]}
                    >
                      <Select
                        mode="multiple"
                        filterOption={false}
                        allowClear
                        placeholder="Selecione o(s) funcionário(s)"
                        notFoundContent={
                          employeesIsLoading ? (
                            <Spin indicator={<i className="fad fa-spinner-third fa-spin" />} />
                          ) : null
                        }
                        onDropdownVisibleChange={(open) => open && this.fetchEmployees()}
                        onSearch={this.fetchEmployeesSearch}
                        onChange={this.onEmployeeChange}
                        onSelect={this.onEmployeeSelect}
                        showSearch
                      >
                        <Select.Option value="todos">Todos</Select.Option>
                        {employees.map((item, index) => (
                          <Select.Option key={index} value={item.id}>
                            {item.nome}
                          </Select.Option>
                        ))}
                      </Select>
                    </Form.Item>
                  </Col>
                  <Col xs={24}>
                    <Form.Item
                      name="layout"
                      label="Descrição Layout"
                      rules={[{ required: true, whitespace: true, message: 'Campo obrigatório.' }]}
                    >
                      <Input ref={(el) => (this.layout = el)} placeholder="Descrição do layout utilizado na integração" />
                    </Form.Item>
                  </Col>
                </Row>
                <div className="integration-form-subsection">
                  <p className="integration-form-subsection-title">Estrutura do arquivo (layout)</p>
                  <p className="integration-form-subsection-description">Defina a ordem e o formato das colunas que serão geradas no arquivo.</p>
                  <ColumnTable
                  notFoundContent={
                    eventColumnDataIsLoading ? (
                      <Spin indicator={<i className="fad fa-spinner-third fa-spin" />} />
                    ) : null
                  }
                  ref={this.columnTableRef}
                  // Se o componente usa outra prop (ex.: "data"), ajuste aqui:
                  eventData={eventData}
                  onRowsChange={this.onLayoutRowsChange}
              />
                </div>
                <Form.Item name="description" label="Descrição" hasFeedback>
                  <TextArea
                    ref={(el) => (this.motivo = el)}
                    placeholder="Informações adicionais sobre o layout e regras de geração do arquivo"
                    autoSize={{ minRows: 3, maxRows: 5 }}
                  />
                </Form.Item>
              </UIFormSection>
            </Col>
            <Col xs={24} xl={12}>
              <UIFormSection
                icon={<i className="fal fa-list-alt" />}
                title="Configuração de eventos"
                description="Mapeie os códigos dos eventos utilizados na integração."
              >
                <EventColumnTable
                notFoundContent={
                  eventDataIsLoading ? (
                    <Spin indicator={<i className="fad fa-spinner-third fa-spin" />} />
                  ) : null
                }
                ref={this.eventColumnTableRef}
                eventData={eventColumnData}
              />
              </UIFormSection>
              <UIInfoBanner
                icon={<i className="fal fa-info-circle" />}
                title="Boas práticas"
                description={
                  <span className="integration-tips">
                    <span className="integration-tips-item"><i className="far fa-check" />Verifique com o fornecedor da folha de pagamento o layout e os formatos exigidos.</span>
                    <span className="integration-tips-item"><i className="far fa-check" />Utilize o tamanho do campo adequado para evitar rejeição do arquivo.</span>
                    <span className="integration-tips-item"><i className="far fa-check" />Certifique-se de que a ordem das colunas está correta conforme o layout.</span>
                  </span>
                }
              />
              <UIFormSection
                icon={<i className="fal fa-eye" />}
                title="Pré-visualização do layout"
                description="Exemplo de como o registro será gerado no arquivo."
              >
                <LayoutPreview
                  rows={layoutRows}
                  typeSections={layoutTypeSections}
                  columnOptions={layoutColumnOptions}
                />
              </UIFormSection>
            </Col>
          </Row>
          <div className="integration-view-banner">
            <UIInfoBanner
              icon={<i className="fal fa-shield-alt" />}
              title="Importante"
              description="Alterações no layout podem impactar a geração do arquivo. Recomendamos atenção ao editar."
            />
          </div>
        </Form>
      </UIDrawerForm>
    )
  }
}

export default Edit